import React from 'react';
import { Link } from 'react-router-dom';

export default function EarlyAccessTeaser() {
  return (
    <section className="py-24 md:py-28 px-6" style={{ backgroundColor: '#f5f6ed' }}>
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-[1.1fr_1fr] gap-12 items-start">
          <div>
            <span className="text-xs uppercase tracking-[0.3em] text-gray-500">Early Access</span>
            <h2 className="text-4xl md:text-5xl font-light mt-4 mb-6 leading-tight">
              Help us build it before we open it up.
            </h2>
            <div className="w-20 h-px bg-gray-900 mb-8" />
            <p className="text-lg text-gray-700 leading-relaxed max-w-xl">
              Two tracks, small cohorts. Apply once — we read every application personally and reply within a week.
            </p>
          </div>

          <div className="grid gap-4">
            <Link
              to="/early-access?track=user"
              className="group block p-6 border border-gray-200 hover:border-gray-900 transition-colors duration-300"
              style={{ backgroundColor: '#fbfcf3' }}
            >
              <div className="flex items-start justify-between gap-4">
                <div>
                  <span className="text-xs uppercase tracking-[0.3em] text-gray-500">For Individuals</span>
                  <h3 className="text-xl font-light mt-2 mb-2">Apply as a user</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Curious mind, care-driven, or just someone who wants a smarter way to understand yourself.
                  </p>
                </div>
                <span className="text-gray-500 group-hover:text-gray-900 group-hover:translate-x-1 transition-all duration-300">→</span>
              </div>
            </Link>

            <Link
              to="/early-access?track=pro"
              className="group block p-6 border border-gray-200 hover:border-gray-900 transition-colors duration-300"
              style={{ backgroundColor: '#fbfcf3' }}
            >
              <div className="flex items-start justify-between gap-4">
                <div>
                  <span className="text-xs uppercase tracking-[0.3em] text-gray-500">For Professionals</span>
                  <h3 className="text-xl font-light mt-2 mb-2">Apply as a clinician or researcher</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Co-shape the clinician side of Bloora — and the picture your future clients arrive with.
                  </p>
                </div>
                <span className="text-gray-500 group-hover:text-gray-900 group-hover:translate-x-1 transition-all duration-300">→</span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
